import { Disclosure } from "@headlessui/react";

export function NavbarLogin(props) {
  return (
    <Disclosure
      as="nav"
      className="fixed z-30 w-full bg-white/90 bg-clip-padding backdrop-filter shadow-md font-walsheim text-lg"
    >
      {({ open }) => (
        <>
          <div className="px-4 sm:px-6 lg:px-8 xl:px-16">
            <div className="h-24 flex justify-center">
              <div className="flex content-center">
                <a className="pt-4" href="/">
                  <img
                    className="block md:hidden h-12 w-full"
                    src="/svg/imagotipo-galilea-14.svg"
                    alt="Galilea"
                  />
                  <img
                    className="hidden md:block h-14 w-auto"
                    src="/svg/imagotipo-galilea-01.svg"
                    alt="Galilea"
                  />
                </a>
              </div>
            </div>
          </div>
        </>
      )}
    </Disclosure>
  );
}
